import React from 'react'
import { useHistory } from "react-router-dom";
import { TimeoutLogic } from "../utils/TimeoutLogic";


const Err404 = (props) => {
    const history = useHistory()
    // const dispatch = useDispatch();
    
    const goBack = () =>{
        history.push('/')
        window.location.reload();

    }

    return (
        <div className="p-5" style={{display: 'flex',  justifyContent:'center', alignItems:'center', height: '80vh'}}>
          <div className="inner" >
                <h5 className="p-3" style={{alignSelf:'center',textAlign:'center'}}>You have refreshed the page or Page not found :( </h5>
                <div className='text-center'>
                 <button onClick={goBack}  className="btn btn-outline-primary btn-sm p-2">Go Back </button>
                </div>           
        </div>
    </div>
    );
}

export default Err404;
